import { render } from "./HeaderNavSix.vue?vue&type=template&id=dfb90ac2"
import script from "./HeaderNavSix.vue?vue&type=script&lang=js"
export * from "./HeaderNavSix.vue?vue&type=script&lang=js"

import "./HeaderNavSix.vue?vue&type=style&index=0&id=dfb90ac2&lang=scss"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__